import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import FormInput from '../../../components/FormHelpers/formField';
import BaseButton from '../../../components/button/BaseButton';
import {isMobile} from '../../../utils/screenUtility';
import DialogWrapper from '../../../components/dialog/Dialog';
import {DialogTypes} from '../../../constants/enums';
import Switch from "../../../components/Switch";

@injectIntl
@inject('dialogStore', 'schoolStore')
@observer
class SchoolDialog extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        const {schoolStore} = this.props;
        if (schoolStore.form.meta.isEditableId) {
            schoolStore.editSchool();
        } else {
            schoolStore.addSchool();
        }
        this.closeDialog();
    };

    closeDialog = () => {
        this.props.dialogStore.closeDialog(DialogTypes.AddEditSchool);
    }

    onSendChatToAdmin = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('sendChatToAdmin', !form.fields.sendChatToAdmin.value);
    }

    onUseDefaultPassword = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('useDefaultPassword', !form.fields.useDefaultPassword.value);
    }

    onIsolateTeachers = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('isolateTeachers', !form.fields.isolateTeachers.value);
    }

    onHideDiscover = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('hideDiscover', !form.fields.hideDiscover.value);
    }

    onIsSilo = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('isSilo', !form.fields.isSilo.value);
    }

    onSharingEnabled = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('sharingEnabled', !form.fields.sharingEnabled.value);
    }

    onEnableSocialShare = () => {
        const {schoolStore} = this.props;
        const {onChange, form} = schoolStore;
        onChange('enableSocialShare', !form.fields.enableSocialShare.value);
    }

    render() {
        const {dialogStore, schoolStore, intl: {formatMessage: translate}} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'invite-modal-root', paper: 'paper'},
            open: dialogStore.getDialogState(DialogTypes.AddEditSchool),
            onClose: this.closeDialog
        };
        const {form, onChange, onBlur, isProcessing} = schoolStore;
        const translateMode = form.meta.isEditableId ? 'editSchool' : 'addSchool';

        return (
            <DialogWrapper {...dialogProps}>
                <div className="invite-modal">
                    <button className="invite-modal-close" onClick={this.closeDialog}>
                        <Close />
                    </button>
                    <h3><FormattedMessage id={`schools.${translateMode}.title`}/></h3>
                    <form onSubmit={this.handleSubmit}>
                        <FormInput
                            name="name"
                            type="text"
                            inputPlaceholder={translate({id: 'schools.form.placeholder.name'})}
                            onChange={onChange}
                            onBlur={onBlur}
                            value={form.fields.name.value}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.sendChatToAdmin.value}
                            name="sendChatToAdmin"
                            onClick={this.onSendChatToAdmin}
                            tooltip={{label: translate({id: 'schools.form.placeholder.sendChatToAdmin'})}}
                            disabled={false}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.useDefaultPassword.value}
                            name="sendChatToAdmin"
                            onClick={this.onUseDefaultPassword}
                            tooltip={{label: translate({id: 'schools.form.placeholder.useDefaultPassword'})}}
                            disabled={false}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.isolateTeachers.value}
                            name="isolateTeachers"
                            onClick={this.onIsolateTeachers}
                            tooltip={{label: translate({id: 'schools.form.placeholder.isolateTeachers'})}}
                            disabled={false}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.hideDiscover.value}
                            name="hideDiscover"
                            onClick={this.onHideDiscover}
                            tooltip={{label: translate({id: 'schools.form.placeholder.hideDiscover'})}}
                            disabled={false}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.isSilo.value}
                            name="isSilo"
                            onClick={this.onIsSilo}
                            tooltip={{label: translate({id: 'schools.form.placeholder.isSilo'})}}
                            disabled={false}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.sharingEnabled.value}
                            name="sharingEnabled"
                            onClick={this.onSharingEnabled}
                            tooltip={{label: translate({id: 'schools.form.placeholder.isSharingEnabled'})}}
                            disabled={false}
                        />
                        <Switch
                            containerClass="upload-record-checkbox"
                            isActive={form.fields.enableSocialShare.value}
                            name="enableSocialShare"
                            onClick={this.onEnableSocialShare}
                            tooltip={{label: translate({id: 'schools.form.placeholder.enableSocialShare'})}}
                            disabled={false}
                        />
                        <BaseButton
                            disabled={!form.meta.isValid || isProcessing}
                            className="invite-modal-btn add-school"
                            type="submit"
                            label={translate({id: `schools.${translateMode}.button`})}
                        />
                    </form>
                </div>
            </DialogWrapper>
        );
    }
}

export default SchoolDialog;
